<template>
  <full-container v-loading="loading" :element-loading-text="loadingText" :padding="0">
    <div slot="header" class="toolbar">
      <el-upload :before-upload="handleUpload" action="default" :disabled="loading">
        <el-button type="primary" size="small" icon="el-icon-upload"> 选择要导入的 .xlsx 表格 </el-button>
      </el-upload>
    </div>
    <el-table :data="datalist[pape]" size="small" stripe height="100%">
      <el-table-column type="expand" :border="false">
        <el-descriptions slot-scope="{ row }" :column="6">
          <el-descriptions-item label="批发价格">{{ row.Price }}</el-descriptions-item>
          <el-descriptions-item label="平台1价格">{{ row.Price1 }}</el-descriptions-item>
          <el-descriptions-item label="平台2价格">{{ row.Price2 }}</el-descriptions-item>
          <el-descriptions-item label="平台3价格">{{ row.Price3 }}</el-descriptions-item>
          <el-descriptions-item label="平台4价格">{{ row.Price4 }}</el-descriptions-item>
          <el-descriptions-item label="平台5价格">{{ row.Price5 }}</el-descriptions-item>
        </el-descriptions>
      </el-table-column>
      <el-table-column prop="Type" label="类别" min-width="80" />
      <el-table-column prop="Category" label="品类" min-width="60" />
      <el-table-column prop="Brand" label="品牌" min-width="100" />
      <el-table-column prop="Code" label="编号" min-width="100" />
      <el-table-column prop="Spec" label="规格" min-width="150" show-overflow-tooltip />
      <el-table-column prop="Usability" label="适用机型" min-width="200" show-overflow-tooltip />
      <el-table-column prop="Weight" label="重量" min-width="60" show-overflow-tooltip />
      <el-table-column prop="Lifetime" label="使用寿命" min-width="60" show-overflow-tooltip />
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <el-pagination :page-size="size" :total="total" @current-change="onPager" />
      <el-button type="primary" size="small" icon="el-icon-caret-right" :disabled="loading" @click="onSubmit(0)">开始导入</el-button>
    </div>
  </full-container>
</template>

<script>
import Vue from 'vue'
import pluginImport from '@d2-projects/vue-table-import'
Vue.use(pluginImport)
export default {
  data () {
    return {
      loading: false,
      loadingText: "",
      datalist: [],
      total: 0,
      pape: 0,
      size: 200,
    }
  },
  methods: {
    //上传文件
    handleUpload (file) {
      if (this.loading) {
        return
      }
      this.loading = true
      this.loadingText = "正在加载文件数据..."
      this.$import
        .xlsx(file)
        .then(({ results }) => {
          console.log(results)
          this.total = results.length
          this.datalist = this.splitArr(results.map(row => {
            return {
              Category: row['分类'],
              Type: row['品类'],
              Brand: row['品牌'],
              Spec: row['品种'] ? String(row['品种']) : null,
              Code: row['编号'] ? String(row['编号']) : null,
              Usability: row['适用机型'] ? String(row['适用机型']) : null,
              Weight: row['碳粉净重'] ? String(row['碳粉净重']) : null,
              Lifetime: row['寿命'] ? String(row['寿命']) : null,
              StockCode1: row['出库编码（莱尔）'] ? String(row['出库编码（莱尔）']) : null,
              StockCode2: row['出库编码（威能达）'] ? String(row['出库编码（威能达）']) : null,
              Price: row['批发价格'],
              Remarks: row['备注'],
            }
          }), this.size)
        })
        .catch((e) => {
          this.$message.error(e)
        }).finally(() => {
          this.loading = false
        })
      return false
    },
    // 分页触发事件
    onPager (val) {
      this.pape = val - 1
    },

    //分页
    splitArr (data, senArrLen) {
      //处理成len个一组的数据
      let data_len = data.length
      let arrOuter_len = data_len % senArrLen === 0 ? data_len / senArrLen : parseInt((data_len / senArrLen) + '') + 1
      let arrSec_len = data_len > senArrLen ? senArrLen : data_len//内层数组的长度
      let arrOuter = new Array(arrOuter_len)//最外层数组
      let arrOuter_index = 0//外层数组的子元素下标
      for (let i = 0; i < data_len; i++) {
        if (i % senArrLen === 0) {
          arrOuter_index++
          let len = arrSec_len * arrOuter_index
          //将内层数组的长度最小取决于数据长度对len取余，平时最内层由下面赋值决定
          arrOuter[arrOuter_index - 1] = new Array(data_len % senArrLen)
          if (arrOuter_index === arrOuter_len)//最后一组
            data_len % senArrLen === 0 ?
              len = data_len % senArrLen + senArrLen * arrOuter_index :
              len = data_len % senArrLen + senArrLen * (arrOuter_index - 1)
          let arrSec_index = 0//第二层数组的索引
          for (let k = i; k < len; k++) {//第一层数组的开始取决于第二层数组长度*当前第一层的索引
            arrOuter[arrOuter_index - 1][arrSec_index] = data[k]
            arrSec_index++
          }
        }
      }
      return arrOuter
    },
    //提交数据
    onSubmit (index) {
      if (index < 0) { index = 0 }

      if (!this.loading) {
        this.loading = true
      }
      this.loadingText = "正在上传第" + (index + 1) + "页"
      this.$apis.product.material.import(this.datalist[index])
        .catch((res) => {
          this.$message.error(res)
        })
        .finally(() => {
          if (!this.datalist[index + 1]) {
            this.$message({ message: '数据全部已上传', type: 'success' })
            this.loading = false
          }
          else {
            this.onSubmit(index + 1)
          }
        })
    }
  }
}
</script>
